<template>
    <div>
        <breadCrumb 
            :icon="'fa-hand-holding-medical'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_treatment`)"
            :subSubCategory="''">
        </breadCrumb>
        <treatment ref="treatment" class="tab-pane"></treatment>
        <!-- <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.treatmentTabs.slice()" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <treatment ref="treatment" :class="{'active': selectedTab === 'treatment'}" class="tab-pane"></treatment>
            <therapy ref="therapy" :class="{'active': selectedTab === 'therapy'}" class="tab-pane"></therapy>
        </div> -->
    </div>
</template>

<script>
import Treatment from './Treatment'
// import Therapy from './Therapy's
import BreadCrumb from './../../Bread_Crumb'
export default {
    name: 'menuTreatment',
    components:{
        BreadCrumb, Treatment, 
    },
    data(){
        return{
            selectedTab: 'treatment'
        }   
    },
}
</script>